var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawtoolsPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ikonit"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,14a2.89,2.89,0,0,0-.78.12l-1.79-2.37a3,3,0,0,0,0-3.5l1.79-2.37A2.89,2.89,0,0,0,17,6a3,3,0,1,0-2.82-4H5.82A3,3,0,1,0,2,5.8v8.4A3,3,0,1,0,5.82,18h8.36A3,3,0,1,0,17,14ZM4,14.17V5.83A3,3,0,0,0,5.82,4h8.36a3.34,3.34,0,0,0,.39.75L12.78,7.12A2.89,2.89,0,0,0,12,7a3,3,0,0,0,0,6,2.89,2.89,0,0,0,.78-.12l1.79,2.37a3.34,3.34,0,0,0-.39.75H5.82A3,3,0,0,0,4,14.17ZM12,11a1,1,0,1,1,1-1A1,1,0,0,1,12,11Zm5-9a1,1,0,1,1-1,1A1,1,0,0,1,17,2ZM3,2A1,1,0,1,1,2,3,1,1,0,0,1,3,2ZM3,18a1,1,0,1,1,1-1A1,1,0,0,1,3,18Zm14,0a1,1,0,1,1,1-1A1,1,0,0,1,17,18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawtoolsPolygon);
export default __webpack_public_path__ + "static/media/drawtools_polygon.921af96a94244c60532f081f7a93cb3c.svg";
export { ForwardRef as ReactComponent };